import { render, staticRenderFns } from "./workflownode.vue?vue&type=template&id=6d1f2dcb&"
import script from "./workflownode.vue?vue&type=script&lang=js&"
export * from "./workflownode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports